<template>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <div class="form-group">
        <p class="form-group-title">Personal</p>
        <div v-show="checkUser">
          <div class="form-col">
            <field :label="$t('class.name')">
              <control
                type="text"
                :placeholder="$t('class.placeholder.name')"
                required
                v-model="employee.name"
                :hasError="!!errors.name"
                id="name"
              />
            </field>
          </div>

          <div class="form-col">
            <field :label="$t('employee.nickname')">
              <control
                type="text"
                :placeholder="$t('employee.placeholder.nickname')"
                v-model="employee.nickname"
              />
            </field>
          </div>

          <div class="form-col">
            <field :label="$t('employee.placeOfBirth')">
              <control
                type="text"
                :placeholder="$t('employee.placeholder.placeOfBirth')"
                v-model="employee.place_of_birth"
              />
            </field>

            <field :label="$t('employee.dateOfBirth')">
              <control
                type="date"
                :placeholder="$t('Date of Birth')"
                v-model="employee.date_of_birth"
              />
            </field>
          </div>

          <div class="form-col">
            <field :label="$t('employee.gender')">
              <check-radio-picker
                name="gender-radio"
                type="radio"
                required
                v-model="employee.gender"
                :options="{
                  'Laki-laki': $t('employee.male'),
                  Perempuan: $t('employee.female'),
                }"
                class="flex justify-between w-36"
              ></check-radio-picker>
            </field>
          </div>
        </div>
        <div class="form-col">
          <field :label="$t('employee.married')">
            <check-radio-picker
              name="married-radio"
              type="radio"
              required
              v-model="employee.married"
              :options="{
                'Belum Menikah': $t('employee.noMarried'),
              }"
              :disabled="isCanUpdated('disable')"
            ></check-radio-picker>
          </field>

          <field :label="'Number of Children'">
            <control
              type="number"
              :min="0"
              v-model="employee.number_children"
              :readonly="isCanUpdated('readonly')"
            />
          </field>
        </div>

        <div class="form-col" v-show="checkUser">
          <field :label="$t('employee.religion')">
            <control-name
              :options="religionList"
              :placeholder="$t('employee.placeholder.religion')"
              v-model="employee.religion"
            />
          </field>

          <field :label="$t('employee.ethnic')">
            <control-name
              :options="ethnicList"
              :placeholder="$t('employee.placeholder.ethnic')"
              v-model="employee.ethnic"
            />
          </field>
        </div>

        <div class="form-col">
          <field :label="$t('employee.address')">
            <control
              type="textarea"
              :placeholder="$t('employee.placeholder.address')"
              v-model="employee.address"
              :disabled="isCanUpdated('disable')"
            />
          </field>
        </div>

        <div class="form-col" v-show="checkUser">
          <field :label="$t('employee.email')">
            <control
              type="email"
              :placeholder="$t('employee.placeholder.email')"
              required
              v-model="employee.email"
              @change="validateEmail"
            />
          </field>
        </div>

        <div class="form-col" v-show="checkUser">
          <field :label="$t('employee.phoneNum')">
            <control
              type="text"
              :placeholder="'Insert Phone Number'"
              v-model="employee.telp"
            />
          </field>

          <field :label="$t('employee.mobileNum')">
            <control
              type="text"
              :placeholder="'Insert Mobile Number'"
              v-model="employee.mobile_no"
            />
          </field>
        </div>

        <div class="form-col" v-show="checkUser">
          <field :label="$t('employee.degree')">
            <control
              type="text"
              :placeholder="$t('employee.placeholder.initialDegree')"
              v-model="employee.initial_degree"
            />
          </field>
        </div>

        <!-- <div class="form-col">
          <field :label="$t('employee.degree')">
            <control type="text" :placeholder="$t('employee.placeholder.finalDegree')" v-model="employee.final_degree" />
          </field>
        </div> -->

        <div class="form-col" v-show="checkUser">
          <field label="Photo profile">
            <input
              type="file"
              accept="image/*"
              v-on:change="onFileChange"
              class="form-control-file"
              id="my-file"
            />
          </field>
        </div>

        <div class="border p-2 mt-3 mb-6">
          <p>Preview Here:</p>
          <div v-if="preview">
            <img :src="preview" class="img-fluid" />
            <p class="mb-0">file name: {{ image.name }}</p>
            <p class="mb-0">size: {{ image.size / 1024 }}KB</p>
          </div>
        </div>
      </div>

      <div class="form-group" v-show="checkUser">
        <p class="form-group-title">Working Information</p>

        <div class="form-col">
          <field :label="$t('employee.section')">
            <select
              v-model="employee.section"
              :placeholder="'Insert Section'"
              required
              class="input-form-select"
            >
              <option value="" disabled selected>
                {{ $t("employee.placeholder.section") }}
              </option>
              <option value="Academic">Academic</option>
              <option value="Non Academic">Non Academic</option>
            </select>
          </field>

          <field :label="$t('workunit.title')">
            <control :options="workunitList" v-model="employee.work_unit_id" />
          </field>
        </div>

        <div class="form-col">
          <field :label="$t('employee.ein')">
            <control
              v-model="employee.ein"
              type="text"
              :placeholder="$t('employee.placeholder.ein')"
              required
            />
          </field>

          <field :label="$t('class.isActive')">
            <CheckRadioPicker
              name="isActive"
              type="switch"
              v-model="employee.show_active"
              :options="{ true: '' }"
            />
          </field>
        </div>

        <!-- <div class="form-col">
            <field :label="$t('Position')" class="w-full md:w-2/2 mb-6 md:mb-0"
                :hasError="errors.position_id">
                <control :options='HRPositionList' v-model="employee.position_id" />
            </field>
        </div> -->

        <!-- <div class="form-col">
            <field :label="$t('Superordinate')" class="w-full md:w-2/2 mb-6 md:mb-0"
                :hasError="errors.must_approve_id">
                <control :options='employeeList' v-model="employee.must_approve_id" />
            </field>
        </div> -->

        <div class="form-col">
          <field :label="$t('Effective Date')">
            <control
              type="date"
              :placeholder="$t('Effective Date')"
              v-model="employee.start_working"
            />
          </field>

          <field :label="$t('Status')">
            <control
              :options="stateList"
              :placeholder="$t('State')"
              v-model="employee.state"
            />
          </field>
        </div>

        <div class="form-col" v-if="employee.state == 'Permanent'">
          <field :label="$t('Decree No.')">
            <control
              type="text"
              :placeholder="$t('Decree No.')"
              v-model="employee.decree_no"
            />
          </field>
        </div>

        <div class="form-col" v-if="employee.state == 'Permanent'">
          <field :label="$t('Decree Date')">
            <control
              type="date"
              :placeholder="$t('Decree Date')"
              v-model="employee.decree_date"
            />
          </field>
        </div>

        <div class="form-col">
          <field :label="$t('employee.noid')" class="w-full">
            <control
              type="text"
              :placeholder="$t('employee.placeholder.noid')"
              v-model="employee.noid"
            />
          </field>
        </div>

        <div class="form-col" v-if="notifEmail === true">
          <notification
            class="w-full"
            color="warning"
            :icon="mdiAlertCircleOutline"
            small
          >
            <b>Warning!</b> Please enter a valid email address
          </notification>
        </div>

        <div class="form-col">
          <field :label="$t('students.cardNumber')">
            <control
              type="text"
              :placeholder="$t('students.placeholder.cardNumber')"
              v-model="employee.id_card_no"
            />
          </field>
        </div>

        <!-- <div class="form-col">
          <field :label="$t('Retirement Age')">
            <control type="number" :min="0" v-model="employee.retirement_age" />
          </field>

          <field :label="$t('Retirement Date')">
            <control type="date" v-model="employee.retirement_date" />
          </field>
        </div> -->

        <div class="form-col">
          <field :label="$t('Retirement Status')">
            <CheckRadioPicker
              name="retirement_status"
              type="switch"
              v-model="employee.retirement_status"
              :options="{ true: '' }"
            />
          </field>
        </div>

        <div class="form-col">
          <field
            class="w-full"
            :label="$t('class.remarks')"
            help="Your question. Max 255 characters"
            :hasError="errors.remarks"
          >
            <control
              type="textarea"
              :placeholder="$t('vaccines.placeholder.description')"
              v-model="employee.description"
              id="description"
              :hasError="!!errors.description"
            />
            <control
              type="textarea"
              :placeholder="$t('class.placeholder.remarks')"
              v-model="employee.remarks1"
              id="remarks1"
            />
            <control
              type="textarea"
              :placeholder="$t('class.placeholder.remarks')"
              v-model="employee.remarks2"
              id="remarks2"
            />
            <control
              type="textarea"
              :placeholder="$t('class.placeholder.remarks')"
              v-model="employee.remarks3"
              id="remarks3"
            />
          </field>
        </div>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="resetForm()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>

  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
  computed
} from "vue";
import { mdiBallot, mdiAlertCircleOutline, mdiCheckBold } from "@mdi/js";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import axios from "axios";

import Control from "@/components/Control";
import ControlName from "@/components/ControlName";
import CheckRadioPicker from "@/components/CheckRadioPicker";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import Notification from "@/components/Notification";

import {
  getEthnicData,
  getReligionData,
  getWorkunit,
  getHRPositionData,
  getEmployeeData,
} from "@/composables/global";
// import { filter } from "core-js/core/array";

export default {
  name: "ClassForm",

  components: {
    Field,
    Control,
    ControlName,
    Loading,
    CheckRadioPicker,
    Datepicker,
    VueTelInput,
    Notification,
    JbButton,
    JbButtons,
  },

  props: {
    showEdit: { type: Boolean, default: false },
    propClass: { type: Object, default: () => ({}) },
    checkUser: { type: Boolean, default: false },
  },

  emits: ["close-modal", "jml-branch", "submit", "reset-modal"],

  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const { ethnicList } = getEthnicData();
    const { religionList } = getReligionData();
    const { workunitList } = getWorkunit();
    const { HRPositionList } = getHRPositionData();
    const userId = localStorage.getItem("user_id");
    const branchId = localStorage.getItem("branch_id");
    const { employeeList } = getEmployeeData({
      user_id: userId,
      branch_id: branchId,
    });

    const selectSection = ["Academic", "Non Academic"];
    const isLoading = ref(false);

    const preview = ref([]);
    const image = ref("");
    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);
    const notifEmail = ref(false);

    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const stateList = ref([
      { id: "Permanent", label: "Permanent Employee" },
      { id: "Contract", label: "Temporary Employee" },
      { id: "Trainee", label: "Part-Time Employee" },
    ]);

    // const employeeOld = reactive({
    //   id: '',
    //   ein: '',
    //   id_card: '',
    //   familycard_id: '',
    //   passport: '',
    //   tin: '',
    //   bank: '',
    //   bank_account: '',
    //   healthcare: '',
    //   social_security: '',
    //   clinic: '',
    //   department: '',
    //   work_unit_id: '',
    //   position_id: '',
    //   must_approve_id: '',
    //   nrp: '',
    //   nuptk: '',
    //   name: '',
    //   nickname: '',
    //   initial_degree: '',
    //   final_degree: '',
    //   degree: '',
    //   place_of_birth: '',
    //   date_of_birth: '',
    //   religion: '',
    //   ethnic: '',
    //   noid: '',
    //   address: '',
    //   telp: '',
    //   mobile_no: '',
    //   email: '',
    //   id_card_no: '',
    //   facebook: '',
    //   twitter: '',
    //   website: '',
    //   photo: '',
    //   section: '',
    //   married: '',
    //   description: '',
    //   is_active: '',
    //   gender: '',
    //   employee_pin: '',
    //   start_working: '',
    //   status: '',
    //   remarksnonactive: '',
    //   retired: '',
    //   doaudit: '',
    //   remarks1: '',
    //   remarks2: '',
    //   remarks3: '',
    //   totalrelatedworkex: '',
    //   softskillkey: '',
    //   bloodtype: '',
    //   created_by: '',
    //   updated_by: '',
    //   state: '',
    //   decree_no: '',
    //   decree_date: '',
    //   retirement_age: '',
    //   expired: ''
    // })

    const employeeOld = reactive({});
    const employee = reactive({
      id: "",
      ein: "",
      id_card: "",
      familycard_id: "",
      passport: "",
      tin: "",
      bank: "",
      bank_account: "",
      healthcare: "",
      social_security: "",
      clinic: "",
      department: "",
      work_unit_id: "",
      nrp: "",
      nuptk: "",
      name: "",
      nickname: "",
      initial_degree: "",
      final_degree: "",
      degree: "",
      place_of_birth: "",
      date_of_birth: "",
      noid: "",
      address: "",
      telp: "",
      mobile_no: "",
      email: "",
      facebook: "",
      twitter: "",
      website: "",
      photo: "",
      section: "",
      married: "",
      description: "",
      is_active: 0,
      show_active: false,
      gender: "",
      employee_pin: "",
      start_working: "",
      status: "",
      remarksnonactive: "",
      retired: "",
      doaudit: 0,
      remarks1: "",
      remarks2: "",
      remarks3: "",
      totalrelatedworkex: "",
      softskillkey: "",
      bloodtype: "",
      created_at: "",
      created_by: "",
      updated_at: "",
      updated_by: "",
      religion: "",
      ethnic: "",
      id_card_no: "",
      sync_date: "",
      idcard_filename: "",
      familycard_filename: "",
      passport_filename: "",
      tin_filename: "",
      position_id: "",
      must_approve_id: "",
      state: "",
      decree_no: "",
      decree_date: "",
      expired: "",
      retirement_age: "",
      retirement_date: "",
      resignation_date: "",
      number_children: 0,
      retirement_status: false,
    });

    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 1024 * 1024) {
          alert("File too big (> 1MB)");
          file.value = "";
        } else {
          const reader = new FileReader();
          reader.onloadend = function () {
            preview.value = reader.result;
          };
          image.value = file;
          reader.readAsDataURL(file);
        }
      } else {
        preview.value = "";
        image.value = "";
      }
    };

    const store = async () => {
      if (
        (employee.state == "Permanent" ||
          !employee.state ||
          employee.state == "") &&
        (!employee.decree_no || employee.decree_no == "")
      ) {
        const txtst =
          !employee.state || employee.state == "" ? "State" : "Decree No";
        toast.error(txtst + " must be filled in.");
        return true;
      }

      isLoading.value = true;

      const url = props.showEdit ? "employee/" + employee.id : "employee";
      const method = props.showEdit ? "PUT" : "POST";

      if (method === "POST") {
        employee.created_by = userlogin;
        employee.photo = preview.value;
      } else {
        employee.updated_by = userlogin;
        employee.photo = preview.value;
      }

      employee.is_active = employee.show_active ? 1 : 0;

      const jsonData = JSON.stringify(employee);
      const configHeaders = {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      };

      console.log("jsonData Employee ", employee);

      await axios({ method, url, data: jsonData, headers: configHeaders })
        .then((response) => {
          if (response.data.success) {
            if (response.data.jmlBranch > 1) {
              emit("jml-branch", response.data.data);
            } else {
              emit("jml-branch", "");
            }
            emit("reset-modal");
            emit("close-modal");
            emit("refresh-list");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.message;
            toast.error(response.data.message);
          }
          isLoading.value = false;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }

          isLoading.value = false;
        });
    };

    const resetForm = () => {
      Object.assign(employee, employeeOld);
      employee.show_active = employee.is_active == 1 ? true : false;
    };

    watchEffect(() => {
      if (props.propClass) {
        Object.assign(employee, props.propClass);
        Object.assign(employeeOld, props.propClass);
        employee.show_active = employee.is_active == 1 ? true : false;
      }
    });


    // Get App Setting
    const appSettingData = ref({})
    const employeeUpdateValue = ref('no')
    const getUpdateSetting = async () => {
      const params = {
        filterColumn: "kode",
        qval: "EMPLOYEE_UPDATE"
      }

      await axios.get("app-setting", { params })
        .then((response) => {
          appSettingData.value = response.data.data
          if (response.data.data && response.data.data.length > 0) {
            employeeUpdateValue.value = response.data.data[0].value || 'no'
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }


    const isCanUpdated = (type) => {
      if (type === 'update') {
        return employeeUpdateValue.value === 'yes'
      }

      if (type === 'readonly' || type === 'disable') {
        return employeeUpdateValue.value === 'no'
      }

      return false
    }

    onMounted(() => {
      getUpdateSetting()
    })

    return {
      str,
      titleStack,
      ethnicList,
      religionList,
      isLoading,
      workunitList,
      HRPositionList,
      employeeList,
      mdiBallot,
      mdiCheckBold,
      mdiAlertCircleOutline,
      router,
      employee,
      selectSection,
      store,
      toast,
      userlogin,
      notifEmail,
      image,
      preview,
      onFileChange,
      errors,
      stateList,
      resetForm,
      appSettingData,
      employeeUpdateValue,
      isCanUpdated,
    };
  },

  methods: {
    clearForm() {
      this.employee = reactive({
        id: "",
        ein: "",
        id_card: "",
        familycard_id: "",
        passport: "",
        tin: "",
        bank: "",
        bank_account: "",
        healthcare: "",
        social_security: "",
        clinic: "",
        department: "",
        work_unit: "",
        nrp: "",
        nuptk: "",
        name: "",
        nickname: "",
        initial_degree: "",
        final_degree: "",
        degree: "",
        place_of_birth: "",
        date_of_birth: "",
        religion: "",
        ethnic: "",
        noid: "",
        address: "",
        telp: "",
        mobile_no: "",
        email: "",
        facebook: "",
        twitter: "",
        website: "",
        photo: "",
        section: "",
        married: "",
        description: "",
        is_active: "",
        gender: "",
        employee_pin: "",
        start_working: "",
        status: "",
        remarksnonactive: "",
        retired: "",
        doaudit: "",
        remarks1: "",
        remarks2: "",
        remarks3: "",
        totalrelatedworkex: "",
        softskillkey: "",
        bloodtype: "",
        created_by: "",
      });
    },

    validateEmail() {
      if (
        !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          this.employee.email
        )
      ) {
        this.notifEmail = true;
      } else {
        this.notifEmail = false;
      }
    },
  },
};
</script>

<style lang="scss">
.form-group {
  width: 100%;
  height: auto;
  border-bottom: 1px solid gray;
  margin-bottom: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .form-group-title {
    width: 100%;
    font-size: 18px;
    font-weight: 600;
  }

  .form-col {
    margin-bottom: 0;
  }
}
</style>
